import React from 'react';
import { Box } from '@mui/material';

const UnauthorizedAccess = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      mt: 10,
      alignItems: 'center',
      fontSize: '3rem',
      fontWeight: 'bold',
    }}
  >
    <p>Sorry, You are not allowed to access this page!</p>
  </Box>
);

export default UnauthorizedAccess;
